'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Avatar = (0, _react.memo)(function (_ref) {
	var picture = _ref.picture,
	    label = _ref.label,
	    className = _ref.className,
	    theme = _ref.theme,
	    shape = _ref.shape,
	    size = _ref.size,
	    component = _ref.component;

	var Dom = component;

	return _react2.default.createElement(
		Dom,
		{ className: (0, _classnames2.default)(className, 'bnc_avatar', 'bnc_avatar--shape--' + shape, 'bnc_avatar--size--' + size, 'bnc_avatar--theme--' + theme, {
				'bnc_avatar--theme--none': picture && picture !== ''
			})
		},
		label && label !== '' && _react2.default.createElement(
			'span',
			{ className: 'bnc_avatar_label' },
			label
		),
		picture && picture !== '' && _react2.default.createElement('span', { className: 'bnc_avatar_picture', style: { 'backgroundImage': 'url(\'' + picture + '\')' } })
	);
});

Avatar.defaultProps = {
	picture: '',
	label: '',
	theme: 'navy',
	shape: 'round',
	size: 'medium',
	className: '',
	component: 'div'
};

Avatar.propTypes = {
	picture: _propTypes2.default.string,
	label: _propTypes2.default.string,
	theme: _propTypes2.default.string,
	shape: _propTypes2.default.string,
	size: _propTypes2.default.string,
	className: _propTypes2.default.string,
	component: _propTypes2.default.string
};

exports.default = Avatar;